import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useEffect, useState } from 'react';

// Register chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SummaryChartComponent = ({ reportData }) => {
  const [chartData, setChartData] = useState({});

  // Function to get summary data
  const getSummaryData = () => {
    // Ensure reportData.bdms exists before mapping over it
    if (!reportData?.bdms || !Array.isArray(reportData.bdms)) {
      return []; // Return an empty array if bdms is not available
    }

    return reportData.bdms.map((bdm) => {
      let totalDone = 0;
      let totalTarget = 0;

      for (let actionKey in bdm.actions) {
        const action = bdm.actions[actionKey]; // Get each action object
        totalDone += action.completed || 0; // Sum completed (done) values
        totalTarget += action.total || 0; // Sum total (target) values
      }

      const completionRate = totalTarget
        ? Math.round((totalDone / totalTarget) * 100)
        : 0;

      return {
        name: bdm.name,
        done: totalDone,
        target: totalTarget,
        completionRate,
      };
    });
  };

  useEffect(() => {
    // Get and format chart data
    const data = getSummaryData(); // Fetch the summary data

    const formattedData = {
      labels: data.map((item) => item.name), // X-axis labels
      datasets: [
        {
          label: 'Actions Done',
          data: data.map((item) => item.done), // Data for 'Actions Done'
          backgroundColor: '#4B80F7',
          borderColor: '#4B80F7',
          borderWidth: 1,
        },
        {
          label: 'Target',
          data: data.map((item) => item.target), // Data for 'Target'
          backgroundColor: '#A5D8FF',
          borderColor: '#A5D8FF',
          borderWidth: 1,
        },
      ],
    };

    setChartData(formattedData);
  }, [reportData]); // Recalculate when `reportData` changes

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          // Custom tooltip formatting
          label: (tooltipItem) => {
            const { datasetIndex, raw } = tooltipItem;
            const label = tooltipItem.dataset.label;
            return `${raw} ${label === 'Actions Done' ? 'Completed' : 'Target'}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'BDM Name',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Count',
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <>
      {chartData.labels && chartData.datasets && (
        <Bar data={chartData} options={options} />
      )}
      </>
  );
};

export default SummaryChartComponent;
